import { EInvoiceAddressSchemeType } from '../enums/eInvoiceAddressSchemeType'

export const DEFAULT_EINVOICE_ADDRESS_SCHEME_TYPE = EInvoiceAddressSchemeType.VAT
